import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  defs,
  linearGradient,
  stop,
} from "recharts";


export function convertTime(minutes) {
  const hours = Math.floor(minutes / 60); // Get the hours
  const remainingMinutes = Math.round(minutes % 60); // Round to avoid floating-point precision issues

  if (hours > 0 && remainingMinutes > 0) {
    return `${hours}h ${remainingMinutes}m`; // "Xh Ym"
  } else if (hours > 0) {
    return `${hours}h`; // Only hours
  } else {
    return `${remainingMinutes}m`; // Only minutes
  }
}

export default function ActivityChart({
  activityData,
  title = "Student Activity Overview",
}) {
  const chartData = Array.isArray(activityData) && activityData.length > 0
    ? activityData.map((ele) => ({
        year: ele.year,
        activeHours: ele.activeHours * 60, // Convert hours to minutes
      }))
    : [];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { year, activeHours } = payload[0].payload;
      return (
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "12px 16px",
            border: "none",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
            backdropFilter: "blur(8px)",
            fontSize: "14px",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          }}
        >
          <p
            style={{
              margin: "0 0 8px 0",
              fontWeight: "600",
              color: "#1a1a1a",
              fontSize: "13px",
            }}
          >
            Year/Group {year}
          </p>
          <p
            style={{
              margin: "0",
              color: "#4318ff",
              fontWeight: "700",
              fontSize: "15px",
            }}
          >
            {convertTime(activeHours)}
          </p>
        </div>
      );
    }
    return null;
  };

  if (chartData.length === 0) {
    return (
      <Container fluid>
        <div
          className="position-relative"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "317px",
          }}
        >
          <p className="data-not-found-cmn">
            {` We couldn’t find any activity for the selected date range. Try changing your filters and check again.`}
          </p>
        </div>
      </Container>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={chartData}
        margin={{ top: 10, right: 20, left: 20, bottom: 50 }}
        barSize={45}
      >
        <defs>
          <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#4318ff" stopOpacity={1} />
            <stop offset="100%" stopColor="#6366f1" stopOpacity={0.8} />
          </linearGradient>
        </defs>
        <CartesianGrid
          strokeDasharray="2 4"
          stroke="#e5e7eb"
          strokeOpacity={0.6}
          horizontal={true}
          vertical={false}
        />
        <XAxis
          dataKey="year"
          tick={{
            fontSize: 13,
            fill: "#374151",
            fontWeight: "500",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          }}
          axisLine={{ stroke: "#d1d5db", strokeWidth: 1 }}
          tickLine={{ stroke: "#d1d5db", strokeWidth: 1 }}
          height={40}
          interval={0}
        />
        <YAxis
          tickFormatter={(value) => convertTime(value)}
          tick={{
            fontSize: 12,
            fill: "#6b7280",
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          }}
          axisLine={{ stroke: "#d1d5db", strokeWidth: 1 }}
          tickLine={{ stroke: "#d1d5db", strokeWidth: 1 }}
          width={65}
        />
        <Tooltip
          content={<CustomTooltip />}
          cursor={{ fill: "rgba(67, 24, 255, 0.05)", radius: 8 }}
        />
        <Bar
          dataKey="activeHours"
          fill="url(#barGradient)"
          name="Active Hours"
          radius={[12, 12, 0, 0]}
          stroke="#4318ff"
          strokeWidth={0}
        />
        <text
          x="50%"
          y="85%"
          textAnchor="middle"
          fontSize="12"
          fill="#6b7280"
          fontWeight="500"
          fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        >
          Year/Group
        </text>
      </BarChart>
    </ResponsiveContainer>
  );
}







































































































